var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEtoileBleu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4970b6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.35,76.88c-.14,0-.28-.04-.4-.13l-16.95-12.32-16.95,12.32c-.24.17-.56.17-.8,0-.24-.17-.34-.48-.25-.76l6.48-19.93-16.95-12.32c-.24-.17-.34-.48-.25-.76.09-.28.35-.47.65-.47h20.95s6.48-19.93,6.48-19.93c.09-.28.35-.47.65-.47s.55.19.65.47l6.47,19.93h20.95c.29,0,.55.19.65.47.09.28,0,.59-.25.76l-16.95,12.32,6.47,19.93c.09.28,0,.59-.25.76-.12.09-.26.13-.4.13ZM75,62.92c.14,0,.28.04.4.13l15.66,11.38-5.98-18.41c-.09-.28,0-.59.25-.76l15.66-11.38h-19.36c-.29,0-.55-.19-.65-.47l-5.98-18.41-5.98,18.41c-.09.28-.35.47-.65.47h-19.36s15.66,11.38,15.66,11.38c.24.17.34.48.25.76l-5.98,18.41,15.66-11.38c.12-.09.26-.13.4-.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.84,77.88c-.21,0-.42-.1-.55-.28-.22-.3-.15-.73.15-.95l8.64-6.3c.3-.22.73-.15.95.15.22.3.15.73-.15.95l-8.64,6.3c-.12.09-.26.13-.4.13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtoileBleu);
export default __webpack_public_path__ + "static/media/etoile_bleu.7c50758d98d9431e407f99f3a813abaa.svg";
export { ForwardRef as ReactComponent };